import request from '@/utils/request'
// import axios from 'axios'
// axios.defaults.headers['Content-Type'] = 'application/json'

// 获取报价列表
export function getQuotationList(data) {
  return request({
    url: '/move/getOffInfoList',
    method: 'post',
    data
  })
}

// 添加报价
export function addQuotation(data) {
  return request({
    url: '/move/addOffer',
    method: 'post',
    data
  })
}

// 更新报价
export function updateQuotation(data) {
  return request({
    url: `/move/editOffer`,
    method: 'post',
    data
  })
}

// 删除报价
export function deleteQuotation(id) {
  return request({
    url: `/quotation/${id}`,
    method: 'delete'
  })
}

// 提交报价审核
export function submitQuotation(data) {
  return request({
    url: `/move/editOffer`,
    method: 'post',
    data
  })
}

// 发送报价给客户
export function sendQuotation(id) {
  return request({
    url: `/quotation/${id}/send`,
    method: 'post'
  })
} 

// 发送报价给客户
export function getExamineFlow(params) {
  return request({
    url: `/move/getExamineFlow`,
    method: 'get',
    params: params
  })
} 

export function getOpportunityQuotations(params) {
  return request({
    url: `/move/getBusinessOffer`,
    method: 'get',
    params: params
  })
} 


export function withdrawQuotation(params) {
  return request({
    url: `/move/repealOffer`,
    method: 'get',
    params: params
  })
} 

export function getExamineList(params) {
  return request({
    url: `/move/getOfferApp`,
    method: 'get',
    params: params
  })
} 



